import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyA5-R1RjKSwkGt6QdvX6OC9KWCA8MwJarQ",
    authDomain: "softcontrol-database-821d0.firebaseapp.com",
    projectId: "softcontrol-database-821d0",
    storageBucket: "softcontrol-database-821d0.appspot.com",
    messagingSenderId: "958172598493",
    appId: "1:958172598493:web:cbcc45b9e1fd2c7791cb34",
    measurementId: "G-R8SPXHLVE5",
};

const app = initializeApp(firebaseConfig);
const database = getFirestore(app);

export { database };
